import { gql } from '@apollo/client';

import { coreSubjectWithStatsFragment, coreSubjectFragment, getSubjectsTreeFragment } from '@ts-core/modules/subjects/graphql/fragments';

export const subjectWithStatsFragment = gql`
  fragment SubjectWithStats on SubjectWithStats {
    ...CoreSubjectWithStats
    score
    exercises {
      id: _id
      code
      questions {
        id: _id
        name
        selectedOptionType
      }
    }
  }
  ${coreSubjectWithStatsFragment}
`;

export const subjectFragment = gql`
  fragment Subject on Subject {
    ...CoreSubject
    enabled
  }
  ${coreSubjectFragment}
`;

export const subjectsTreeFragment = getSubjectsTreeFragment(subjectFragment);
